<template>
  <div>
    <basic-container>
      <avue-crud :option="tableOption" :data="tableData" :table-loading="tableLoading" :page="page" ref="crud"
        @search-change="searchChange" @refresh-change="refreshChange(page)" @row-save="handleSave"
        @row-update="handleUpdate" @selection-change="handleSelectionChange" @size-change="pageSizeChange"
        @current-change="pageChange">

        <template slot="menuLeft">
          <el-button type="text" icon="el-icon-download" size="mini" plain
            @click.stop="downloadExcelWorkOrder">下载所有Excel</el-button>
          <el-button type="text" icon="el-icon-download" size="small" plain
            v-if="permission.JOINS_SALES_CLOUD_DOWNLOAD_CODE_MERCHANTS" @click.stop=downloadCode({type:1})>下载商户报单通用码</el-button>
          <el-button type="text" icon="el-icon-download" size="small" plain
            v-if="permission.JOINS_SALES_CLOUD_DOWNLOAD_CODE_CUSTOMER" @click.stop=downloadCode({type:2})>下载客户报单通用码</el-button>
        </template>
        <template slot-scope="scope" slot="menu">
          <el-button type="text" icon="el-icon-edit" size="small" plain
            v-if="permission.JOINS_SALES_CLOUD_EDIT_MERCHANTS" @click.stop="handleEdit(scope.row, scope.index)">编辑
          </el-button>
          <el-button type="text" icon="el-icon-news" size="small" plain
            @click.stop="handleMark(scope.row)">标记</el-button>
        </template>
        <template slot-scope="scope" slot="menuBtn">
          <el-button type="text" icon="el-icon-view" size="small" plain @click.stop="handleView(scope.row)">查看报单
          </el-button>
          <el-button type="text" icon="el-icon-plus" size="small" plain
            v-show="scope.row.status == 'WAIT_AUDIT' && scope.row.reference && permission.JOINS_SALES_CLOUD_WAIT_AUDIT"
            @click.stop="handleRebates(scope.row)">待返利</el-button>
          <el-button type="text" icon="el-icon-download" size="small" plain
            v-if="permission.JOINS_SALES_CLOUD_ADD_DELIVERY" @click.stop="handleDelivery(scope.row)">生成提货单</el-button>
          <!-- <el-button type="text" icon="el-icon-view" size="small" plain v-if="scope.row.deliveryOrderId"
            @click.stop="viewDelivery(scope.row)">查看提货单</el-button> -->
          <el-button type="text" icon="el-icon-view" size="small" plain
            @click="handleViewServiceDiary(scope.row.id)">查看日志
          </el-button>
          <el-button v-if="scope.row.isRefuse !== 'YES' && scope.row.orderStatus !== 'BACK'" type="text"
            icon="el-icon-back" size="small" plain @click.stop="handleReturn(scope.row, scope.index)">退回</el-button>
          <el-button v-if="scope.row.orderStatus == 'WAIT_FOR_ASSIGN'" type="text" icon="el-icon-d-arrow-left"
            size="small" plain @click.stop="handleDelayedInstallation(scope.row, scope.index)">延迟安装</el-button>
          <el-button v-if="scope.row.orderStatus !== 'WAIT_PAY' && scope.row.payMoney" type="text"
            icon="el-icon-mobile-phone" size="small" plain @click.stop="handleReturnMoney(scope.row)">退款</el-button>
          <el-button type="text" icon="el-icon-delete" size="small" plain
            v-if="permission.JOINS_SALES_CLOUD_DEL_MERCHANTS" @click.stop="handleDel()">删除</el-button>
          <!-- 报售后 -->
          <el-button
            v-show="scope.row.orderStatus !== 'WAIT_FOR_ASSIGN'"
            type="text" icon="el-icon-news" size="small" plain @click.stop="handleAfterSales(scope.row)">报售后
          </el-button>
        </template>
        <template slot-scope="scope" slot="picUrl">
          <viewer :images="formmaterImage(scope.row.picUrl)">
            <img v-for="src in formmaterImage(scope.row.picUrl)" :src="src" :key="src" width="20">
          </viewer>
        </template>
        <template slot-scope="scope" slot="refundStatus">
          <span v-if="scope.row.refundStatus == 'NOT_REFUNDED'">未退款</span>
          <span v-if="scope.row.refundStatus == 'PARTIAL_REFUND'">部分退款</span>
          <span v-if="scope.row.refundStatus == 'REFUND_PAY'">已退款</span>
        </template>
        <template slot-scope="scope" slot="actualInstallTime">
          <span>{{ scope.row.actualInstallTime == 0 ? '' : scope.row.actualInstallTime }}</span>
        </template>
      </avue-crud>
      <!-- 提货单弹窗 -->
      <el-dialog title="生成提货单" :visible.sync="dialogVisible" width="60%" :close-on-click-modal="false">
        <el-card>
          <div slot="header" class="clearfix">
            <span style="float: left;">客户信息</span>
          </div>
          <el-form :model="info" label-width="100px" :inline="true">
            <el-form-item label="客户姓名:">
              <span>{{ info.customName }}</span>
            </el-form-item>
            <el-form-item label="客户电话:">
              <span>{{ info.customMobile }}</span>
            </el-form-item>
            <el-form-item label="客户地址:">
              <span>{{ info.customAddress }}</span>
            </el-form-item>
            <el-form-item label="店铺名称:">
              <span>{{ info.shopName }}</span>
            </el-form-item>
          </el-form>
        </el-card>
        <el-card>
          <div slot="header" class="clearfix">
            <span style="float: left;">提货产品</span>
            <el-button style="float: right; padding: 3px 0" type="text" disabled>发起提货↓</el-button>
          </div>
          <el-table :data="deliveryOrderInfo" border size="mini">
            <el-table-column prop="productName" label="提货产品名称" align="center" width="200" />
            <!-- 选择前仓 -->
            <el-table-column prop="warehouseId" label="前仓" align="center" width="200">
              <template slot-scope="scope">
                <el-select v-model="scope.row.warehouseId" placeholder="请选择前仓">
                  <el-option v-for="item in WarehouseList" :key="item.id" :label="item.warehouseName" :value="item.id">
                  </el-option>
                </el-select>
              </template>
            </el-table-column>
            <!-- 选择工程师 -->
            <el-table-column prop="engineerId" label="工程师" align="center" width="200">
              <template slot-scope="scope">
                <el-select v-model="scope.row.engineerId" placeholder="请选择工程师" filterable remote
                  :remote-method="(query) => handleRemote(query, scope.row)" clearable>
                  <el-option v-for="item in scope.row.engineerInfo" :key="item.id" :label="item.realName"
                    :value="item.id">
                  </el-option>
                </el-select>
              </template>
            </el-table-column>
            <!-- 选择预计安装时间 -->
            <el-table-column prop="installTimeStart" label="开始时间" align="center" width="200">
              <template slot-scope="scope">
                <el-date-picker v-model="scope.row.installTimeStart" type="datetime" placeholder="选择预计安装时间"
                  value-format="timestamp" format="yyyy-MM-dd HH:mm:ss" clearable></el-date-picker>
              </template>
            </el-table-column>
            <el-table-column prop="installTimeEnd" label="结束时间" align="center" width="200">
              <template slot-scope="scope">
                <el-date-picker v-model="scope.row.installTimeEnd" type="datetime" placeholder="选择预计安装时间结束"
                  value-format="timestamp" format="yyyy-MM-dd HH:mm:ss" clearable></el-date-picker>
              </template>
            </el-table-column>
            <!-- 提货按钮 -->
            <el-table-column label="操作" align="center" width="200">
              <template slot-scope="scope">
                <el-button type="text" :icon="scope.row.isUpdate ? 'el-icon-edit' : 'el-icon-check'" size="mini"
                  @click="confirm(scope.row)"
                  :loading="!!scope.row.submitting"
                  :disabled="!!(scope.row.serviceOrderId||scope.row.shopSignPic||scope.row.consigneeSignPic||scope.row.submitting)">
                  {{ scope.row.submitting ? '提交中' : (scope.row.isUpdate ? '修改' : '提货') }}
                </el-button>
                <el-button v-if="scope.row.shopSignPic || scope.row.consigneeSignPic" type="text"
                  icon="el-icon-sort" size="mini" @click="openTransferDialog(scope.row)">转货</el-button>
                <el-button v-if="scope.row.shopSignPic || scope.row.consigneeSignPic" type="text"
                  icon="el-icon-back" size="mini" @click="openReturnGoodsDialog(scope.row)">退货</el-button>
                <el-button type="text"
                  icon="el-icon-document" size="mini" @click="openOperationLogDialog(scope.row)">操作日志</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-card>
        <span slot="footer" class="dialog-footer">
          <el-button type="text" @click="cancel">
            <i class="el-icon-close"></i>
            取 消</el-button>
          <!-- <el-button v-if="info.orderStatus!=='TO_BE_EVALUATED'" type="text" @click="handleBulkDelivery">
            <i class="el-icon-check"></i> 一键提货
          </el-button> -->
        </span>
      </el-dialog>
      <el-dialog :visible.sync="reasonDialog" title="退回理由" center width="300px">
        <div style="display: flex;">
          <el-input type="textarea" :rows="4" placeholder="请输入退回理由" v-model="returnReason"></el-input>
        </div>
        <div class="typeButton">
          <el-button round size="mini" @click="reasonDialog = false">&nbsp;&nbsp;&nbsp;取消&nbsp;&nbsp;&nbsp;</el-button>
          <el-button round type="primary" size="mini"
            @click="typeEditOk">&nbsp;&nbsp;&nbsp;确定&nbsp;&nbsp;&nbsp;</el-button>
        </div>
      </el-dialog>
      <el-dialog :visible.sync="delayedInstallationReasonDialog" title="延迟安装理由" center width="500px">
        <el-form label-width="150px">
          <el-row>
            <el-col :span="24">
              <el-form-item label="延迟安装时间" prop="installTimeStart">
                <el-date-picker v-model="delayTime" type="datetime" placeholder="选择延迟安装时间" value-format="timestamp"
                  format="yyyy-MM-dd HH:mm:ss" clearable></el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="延迟安装理由" prop="reason">
                <el-input type="textarea" :rows="4" placeholder="请输入延迟安装理由" v-model="returnReason"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div class="typeButton">
          <el-button round size="mini"
            @click="delayedInstallationReasonDialog = false">&nbsp;&nbsp;&nbsp;取消&nbsp;&nbsp;&nbsp;</el-button>
          <el-button round type="primary" size="mini"
            @click="delayedInstallationReasonOk">&nbsp;&nbsp;&nbsp;确定&nbsp;&nbsp;&nbsp;</el-button>
        </div>
      </el-dialog>
      <el-dialog :visible.sync="handleReturnMoneyDialog" title="退款" center width="400px">
        <div style="display: flex; flex-direction: column; gap: 20px; padding: 10px;">
          <!-- 退款理由 -->
          <div style="display: flex; flex-direction: column; gap: 5px;">
            <label style="font-size: 14px; color: #606266;">退款理由</label>
            <el-input type="textarea" :rows="4" placeholder="请输入退款理由" v-model="returnReasons"
              style="width: 100%;"></el-input>
          </div>

          <!-- 退款金额 -->
          <div style="display: flex; flex-direction: column; gap: 5px;">
            <label style="font-size: 14px; color: #606266;">退款金额</label>
            <el-input-number v-model="returnMoney" :min="0" :max="100000" label="退款金额" placeholder="请输入退款金额"
              style="width: 100%;"></el-input-number>
          </div>

          <!-- 操作按钮 -->
          <div style="display: flex;justify-content: flex-end;gap: 10px;margin-top: 10px;">
            <el-button round size="mini" @click="handleReturnMoneyDialog = false"
              style="background-color: #f4f4f5; color: #606266;">
              取消
            </el-button>
            <el-button round type="primary" size="mini" @click="returnMoneyOk">
              确定
            </el-button>
          </div>
        </div>
      </el-dialog>
      <view-service-diary :visibleRecord.sync="viewServiceDiaryVisible" :DiaryId="DiaryId" />
      <after-sales :visibleAfterSales.sync="handleAfterSalesDialog" :afterSalesId="afterSalesId"
        :WarehouseList="WarehouseList" />
      <merchant-view :visible.sync="viewDialogVisible" :id="viewId" />
      <merchant-edit :visible.sync="editDialogVisible" :id="editId" @refresh="handleList" />
      <el-dialog :visible.sync="markDialogVisible" title="标记安装类型" width="400px" center>
        <el-radio-group v-model="markType">
          <el-radio :label="'1'">业主自安装</el-radio>
          <el-radio :label="'2'">公司安装</el-radio>
        </el-radio-group>
        <span slot="footer" class="dialog-footer">
          <el-button @click="markDialogVisible = false">取消</el-button>
          <el-button type="primary" @click="handleMarkOk">确定</el-button>
        </span>
      </el-dialog>
      <!-- 转货弹窗 -->
      <el-dialog :visible.sync="transferDialogVisible" title="转货" width="500px" center :close-on-click-modal="false">
        <el-form label-width="120px">
          <el-form-item label="目标工程师">
            <el-select v-model="transferForm.targetEngineerId" placeholder="请搜索工程师" filterable remote
              :remote-method="handleTransferEngineerSearch" clearable style="width: 100%;">
              <el-option v-for="item in transferEngineerList" :key="item.id" :label="item.realName" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="备注">
            <el-input type="textarea" :rows="3" placeholder="请输入备注" v-model="transferForm.remark"></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="transferDialogVisible = false">取消</el-button>
          <el-button type="primary" @click="confirmTransfer">确定</el-button>
        </span>
      </el-dialog>
      <!-- 退货弹窗 -->
      <el-dialog :visible.sync="returnGoodsDialogVisible" title="退货" width="700px" center :close-on-click-modal="false">
        <el-form label-width="100px" style="margin-bottom: 15px;">
          <el-form-item label="退回前仓">
            <el-select v-model="returnGoodsForm.warehouseId" placeholder="请选择前仓" style="width: 100%;">
              <el-option v-for="item in WarehouseList" :key="item.id" :label="item.warehouseName" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <!-- 退货快递及单号 -->
          <el-form-item label="退货快递单号">
            <el-input type="textarea" :rows="3" placeholder="请输入退货快递及单号" v-model="returnGoodsForm.remark"></el-input>
          </el-form-item>
        </el-form>
        <el-table :data="returnGoodsForm.goodsList" border size="mini">
          <el-table-column prop="goodsName" label="商品名称" align="center"></el-table-column>
          <el-table-column prop="maxNum" label="可退数量" align="center" width="100"></el-table-column>
          <el-table-column label="退货数量" align="center" width="200">
            <template slot-scope="scope">
              <el-input-number v-model="scope.row.num" :min="0" :max="scope.row.maxNum"
                :precision="0" :step="1" size="mini" controls-position="right"></el-input-number>
            </template>
          </el-table-column>
        </el-table>
        <span slot="footer" class="dialog-footer">
          <el-button @click="returnGoodsDialogVisible = false">取消</el-button>
          <el-button type="primary" @click="confirmReturnGoods">确定</el-button>
        </span>
      </el-dialog>
      <!-- 操作日志弹窗 -->
      <el-dialog :visible.sync="operationLogDialogVisible" title="操作日志" width="800px" center :close-on-click-modal="false" append-to-body>
        <el-table :data="operationLogList" border size="mini" style="width: 100%" height="400" v-loading="operationLogLoading">
          <el-table-column prop="createTime" label="操作时间" align="center" width="160"></el-table-column>
          <el-table-column prop="operationTypeText" label="操作类型" align="center" width="100"></el-table-column>
          <el-table-column prop="createBy" label="操作人" align="center" width="90"></el-table-column>
          <el-table-column prop="fromUserName" label="从" align="center" width="90"></el-table-column>
          <el-table-column prop="toUserName" label="到" align="center" width="90"></el-table-column>
          <el-table-column prop="remark" label="备注" align="center"></el-table-column>
        </el-table>
        <span slot="footer" class="dialog-footer">
          <el-button @click="operationLogDialogVisible = false">关闭</el-button>
        </span>
      </el-dialog>
    </basic-container>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { resolveUrlPath, formatterTime } from "@/util/util";
import { waterProjectTableOption } from "@/const/work/waterProject/merchantsOption";
import { findPureWaterGoodsByRootDepartId } from "@/api/salesCloud/goodsQr";
import { getGoodList,addDeliveryOrder, toBulkDelivery, updateDeliveryOrder, findWaterProject, addWaterProject, editWaterProject, delWaterProject, findWaterProjectAll, downloadExcelCustomsDeclaration, handleRebates, getDownloadCode, getRootDepartmentId, stockRemovalReturn, handleDelayedInstallation, returnMoney, getMerchantOrder, getUserInfo, setInstallType, transferGoods, returnGoods, getDeliveryOrderOperationLog } from "@/api/work/waterProject/merchants"
import { getWarehouseList } from "@/api/salesCloud/warehouse";
import { findUserList } from "@/api/work/projectService";
import ImageUpload from "@/components/imageUpload/ImageUpload";
import ViewServiceDiary from "./components/viewServiceDiary/index.vue";
import afterSales from "./components/afterSales/index.vue";
import MerchantView from "./view.vue";
import MerchantEdit from "./edit.vue";
export default {
  name: "waterProject",
  components: {
    ImageUpload,
    ViewServiceDiary,
    afterSales,
    MerchantView,
    MerchantEdit
  },
  data() {
    return {
      tableOption: waterProjectTableOption, //表格设置属性
      tableData: [], //表格的数据
      tablePage: 1,
      tableLoading: false,
      deliveryOrderInfo: [],
      returnReason: "",
      info: {},
      reasonDialog: false,
      rules: {
        warehouseId: [
          { required: true, message: "请选择前仓", trigger: "change" }
        ],
        engineerId: [
          { required: true, message: "请选择工程师", trigger: "change" }
        ],
        installTimeStart: [
          { required: true, message: "请选择预计安装时间开始", trigger: "change" }
        ],
        installTimeEnd: [
          { required: true, message: "请选择预计安装时间结束", trigger: "change" }
        ]
      },
      page: {
        total: 0, //总页数
        currentPage: 1, //当前页数
        pageSize: 30 //每页显示多少条
      },
      viewServiceDiaryVisible: false,
      handleReturnMoneyDialog: false,
      handleAfterSalesDialog: false,
      afterSalesId: "",
      returnReasons: "",
      returnMoney: 0,
      dialogVisible: false,
      WarehouseList: [],
      downloadData: {},
      rootDepartmentId: "",
      superiors: [],
      superior: {},
      picUrl: "",
      fileList: [],
      delayedInstallationReasonDialog: false,
      DiaryId: "",
      delayTime: "",
      goodsList: [],
      currentDeliveryRow: null, // 当前提货单弹窗对应的行数据，用于刷新弹窗
      markDialogVisible: false,
      markType: '', // 1: 业主自安装, 2: 公司安装
      markRow: null,
      // 转货
      transferDialogVisible: false,
      transferForm: {
        declarationId: '',
        deliveryOrderId: '',
        targetEngineerId: '',
        remark: '',
      },
      transferEngineerList: [],
      // 查看/编辑弹窗
      viewDialogVisible: false,
      viewId: '',
      editDialogVisible: false,
      editId: '',
      // 退货
      returnGoodsDialogVisible: false,
      returnGoodsForm: {
        declarationId: '',
        remark: '',
        deliveryOrderId: '',
        warehouseId: '',
        goodsList: [],
      },
      // 操作日志
      operationLogDialogVisible: false,
      operationLogList: [],
      operationLogLoading: false,
    };
  },
  created() {
    this.handleList();
    this.handleWarehouseList();
  },
  watch: {
    tableData() {
      return this.tableData.map(item => {
        if (item.actualInstallTime !== 0 && item.actualInstallTime !== null) {
          item.actualInstallTime = formatterTime(item.actualInstallTime);
          return item;
        } else {
          return item == '';
        }
      });
    }
  },
  mounted() {
  },
  computed: {
    ...mapGetters(["permission"])
  },
  props: [],
  methods: {
    returnMoneyOk() {
      let params = {
        id: this.rowId,
        reason: this.returnReasons,
        refundAmount: this.returnMoney
      }
      returnMoney(params).then(res => {
        this.handleReturnMoneyDialog = true;
        if (res.code == "200") {
          this.$message({
            showClose: true,
            message: "退款中...",
            type: "primary"
          });
          setTimeout(() => {
            this.returnReasons = "";
            this.returnMoney = 0;
            this.handleList();
          }, 1000);
          this.handleReturnMoneyDialog = false;
        } else {
          this.$message({
            showClose: true,
            message: "退款中...",
            type: "error"
          });
          setTimeout(() => {
            this.$message({
              showClose: true,
              message: res.message,
              type: "error"
            });
            this.returnReasons = "";
            this.returnMoney = 0;
            this.handleList();
          }, 2000);
          this.handleReturnMoneyDialog = false;
        }
      })
    },
    handleReturnMoney(row) {
      // 输入退款备注和退款金额
      this.handleReturnMoneyDialog = true;
      this.rowId = row.id;
    },
    handleViewServiceDiary(id) {
      this.DiaryId = id;
      this.viewServiceDiaryVisible = true;
    },
    closeViewServiceDiaryDialog() {
      this.viewServiceDiaryVisible = false;
    },
    handleReturn(row) {
      this.rowId = row.id;
      this.reasonDialog = true;
    },
    handleDelayedInstallation(row) {
      // reason和id
      this.rowId = row.id;
      this.delayedInstallationReasonDialog = true;
    },
    delayedInstallationReasonOk() {
      let params = {
        id: this.rowId,
        delayTime: this.delayTime,
        reason: this.returnReason
      };
      if (this.returnReason.replace(/(^\s+)|(^\s+$)/g, "")) {
        if (this.delayTime == "") {
          this.$message({
            showClose: true,
            message: "请选择延迟安装时间",
            type: "error"
          });
          return;
        }
        handleDelayedInstallation(params).then(res => {
          this.delayedInstallationReasonDialog = true;
          if (res.code == "200") {
            this.$message({
              showClose: true,
              message: "延迟安装中...",
              type: "primary"
            });
            setTimeout(() => {
              this.$message({
                showClose: true,
                message: "延迟安装成功",
                type: "success"
              });
              this.returnReason = "";
              this.delayTime = "";
              this.rowId = "";
              this.handleList();
            }, 2000);
            this.delayedInstallationReasonDialog = false;
          } else {
            this.$message({
              showClose: true,
              message: "申请延迟安装中...",
              type: "error"
            });
            setTimeout(() => {
              this.$message({
                showClose: true,
                message: res.message,
                type: "error"
              });
              this.returnReason = "";
              this.delayTime = "";
              this.rowId = "";
              this.handleList();
            }, 2000);
            this.delayedInstallationReasonDialog = false;
          }
        });
      } else {
        this.$message({
          showClose: true,
          message: "请填写延迟安装理由",
          type: "error"
        });
      }
    },
    typeEditOk() {
      let params = {
        id: this.rowId,
        refuseReason: this.returnReason
      };
      if (this.returnReason.replace(/(^\s+)|(^\s+$)/g, "")) {
        stockRemovalReturn(params).then(res => {
          this.reasonDialog = true;
          if (res.code == "200") {
            this.$message({
              showClose: true,
              message: "退回中...",
              type: "primary"
            });
            setTimeout(() => {
              this.$message({
                showClose: true,
                message: "退回成功",
                type: "success"
              });
              this.returnReason = "";
              this.handleList();
            }, 2000);
            this.reasonDialog = false;
          } else {
            this.$message({
              showClose: true,
              message: "退回中...",
              type: "error"
            });
            setTimeout(() => {
              this.$message({
                showClose: true,
                message: res.message,
                type: "error"
              });
              this.returnReason = "";
              this.handleList();
            }, 2000);
            this.reasonDialog = false;
          }
        });
      } else {
        this.$message({
          showClose: true,
          message: "请填写拒绝理由",
          type: "error"
        });
      }
    },
    // cancel取消
    cancel() {
      this.dialogVisible = false;
      // 清空表单
      this.deliveryOrderInfo = [];
      this.currentDeliveryRow = null;
    },
    confirm(row) {
      row.engineerInfo = [];
      row.status = "WAIT_FOR_DELIVERY";
      // 校验所有
      if (row.warehouseId == "" || row.engineerId == "" || row.installTimeStart == "" || row.installTimeEnd == "") {
        this.$message({
          showClose: true,
          message: "请填写完整信息",
          type: "error",
        });
        return;
      }

      // 防止同一行重复提交
      if (row.submitting) {
        return;
      }
      row.submitting = true;

      // 多产品时不自动关闭弹窗,继续处理其他产品
      const isMultiProduct = this.deliveryOrderInfo && this.deliveryOrderInfo.length > 1;

      const handleSuccess = (msg) => {
        this.$message({
          showClose: true,
          message: msg,
          type: "success",
        });
        this.handleList();
        // 关键: 重新加载该订单下所有提货单的最新数据,
        // 保证弹窗内每一条产品记录都展示最新状态
        this.refreshDeliveryInfo();
        // 单产品时才自动关闭弹窗,多产品时由用户手动关闭
        if (!isMultiProduct) {
          this.dialogVisible = false;
        }
      };

      const handleError = (msg) => {
        this.$message({
          showClose: true,
          message: msg,
          type: "error",
        });
      };

      if (row.isUpdate) {
        updateDeliveryOrder(row).then((res) => {
          if (res.code == "200") {
            handleSuccess("修改提货单成功");
          } else {
            handleError(res.message);
          }
        }).finally(() => {
          row.submitting = false;
        });
      } else {
        addDeliveryOrder(row).then((res) => {
          if (res.code == "200") {
            handleSuccess("生成提货单成功");
          } else {
            handleError(res.message);
          }
        }).finally(() => {
          row.submitting = false;
        });
      }
    },
    // 重新加载当前订单的提货单数据,确保弹窗内每条记录都为最新状态
    refreshDeliveryInfo() {
      if (!this.currentDeliveryRow) return;
      const row = this.currentDeliveryRow;
      getMerchantOrder(row.id).then(res => {
        if (res.code === "200") {
          const data = JSON.parse(res.data).rows[0];
          this.info = data;
          if (data.list && data.list.length > 0) {
            this.findPureWaterGoodsByRootDepartId(data.list, row);
          } else {
            getGoodList(row.id).then(res => {
              if (res.code === "200") {
                const data = JSON.parse(res.data);
                this.findPureWaterGoodsByRootDepartId(data, row);
              } else {
                this.$message({
                  showClose: true,
                  message: res.message,
                  type: "error"
                });
              }
            });
          }
        } else {
          this.$message({
            showClose: true,
            message: res.message,
            type: "error"
          });
        }
      });
    },
    // handleRemote远程搜索工程师
    handleRemote(query, row) {
      // eslint-disable-next-line no-control-regex
      if (/[^\x00-\xff]/.test(query) || /^\d{8,}$/.test(query)) {
        row.engineerInfo = [];
        setTimeout(() => {
          let params = {
            type: "JOINS_ENGINEER",
            mobile: query,
          };
          findUserList(params).then((res) => {
            if (res.code == "200") {
              let data = JSON.parse(res.data);
              row.engineerInfo = data;
              
            } else {
              this.$message({
                showClose: true,
                message: res.message,
                type: "error",
              });
            }
          });
        }, 200);
      }
    },
    handleWarehouseList() {
      let params = {
        page: 1,
        size: 100,
      };
      getWarehouseList(params).then((res) => {
        let data = JSON.parse(res.data);
        console.log('index.vue ~ line: 585 ~ data ->', data);
        this.WarehouseList = data.rows;
      });
    },
    // handleDelivery生成提货单
    handleDelivery(row) {
      // 打开生成提货单弹窗
      this.dialogVisible = true;
      this.currentDeliveryRow = row;
      getMerchantOrder(row.id).then(res => {
        if (res.code === "200") {
          const data = JSON.parse(res.data).rows[0];
          this.info = data;
          
          if (data.list && data.list.length > 0) {
            this.findPureWaterGoodsByRootDepartId(data.list, row);
          } else {
            getGoodList(row.id).then(res => {
              if (res.code === "200") {
                const data = JSON.parse(res.data);
                
                this.findPureWaterGoodsByRootDepartId(data, row);
              } else {
                this.$message({
                  showClose: true,
                  message: res.message,
                  type: "error"
                });
              }
            })
          }
        } else {
          this.$message({
            showClose: true,
            message: res.message,
            type: "error"
          });
        }
      });
    },
    async findPureWaterGoodsByRootDepartId(selectedGoods, row) {
      const type = 'PURE_WATER';
      const res = await findPureWaterGoodsByRootDepartId(type);
      if (res.code === "200") {
        let data = JSON.parse(res.data);
        this.goodsList = data;

        // 对 selectedGoods 进行异步 map
        const deliveryOrderInfoPromises = selectedGoods.map(async item => {
          let engineerInfo = [];
          if (item.deliveryOrder && item.deliveryOrder.engineerId) {
            const userRes = await getUserInfo(item.deliveryOrder.engineerId);
            if (userRes.code === "200") {
              let userData = typeof userRes.data === 'string' ? JSON.parse(userRes.data) : userRes.data;
              userData.realName = userData.realName + '(' + userData.mobile + ')';
              engineerInfo = [userData];
            } else {
              this.$message({
                showClose: true,
                message: userRes.message,
                type: "error"
              });
            }
          }

          return {
            ...item.deliveryOrder,
            isUpdate: item.deliveryOrder ? true : false,
            shopId: row.shopId,
            declarationId: row.id,
            goodsId: item.goodsId,
            declarationGoodsId: item.id,
            goodsNum: item.num,
            productName: this.goodsList.find(g => g.id === item.goodsId)
              ? this.goodsList.find(g => g.id === item.goodsId).name+'*'+item.num
              : "",
            goodsRealName: this.goodsList.find(g => g.id === item.goodsId)
              ? this.goodsList.find(g => g.id === item.goodsId).name
              : "",
            warehouseId: item.deliveryOrder ? item.deliveryOrder.warehouseId : "",
            engineerId: item.deliveryOrder ? item.deliveryOrder.engineerId : "",
            installTimeStart: item.deliveryOrder ? item.deliveryOrder.installTimeStart : "",
            installTimeEnd: item.deliveryOrder ? item.deliveryOrder.installTimeEnd : "",
            engineerInfo: engineerInfo // 这里已经是一个数组
          };
        });

        // 等待所有 Promise 完成后，再赋值给 deliveryOrderInfo
        this.deliveryOrderInfo = await Promise.all(deliveryOrderInfoPromises);
        console.log(this.deliveryOrderInfo)
        
      } else {
        this.$message({
          showClose: true,
          message: res.message,
          type: "error"
        });
      }
    },
    // 查看提货单
    viewDelivery(row) {
      // 查看
      let obj = {
        label: "查看提货单",
        value: "/work/eliveryOrder/view",
        query: { id: row.deliveryOrderId, type: row.type },
      };
      this.$router.push({
        path: resolveUrlPath(obj.value, obj.label),
        query: obj.query,
      });
    },
    // 生成商家码并显示弹窗
    downloadCode(type) {
      this.$confirm("是否确认生成通用码?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        const data = {
          scene: this.rootDepartmentId,
          page: type.type == 1 ? "pages/waterProject/install/install" : "pages/waterProject/customer/customer",
          width: "340",
          clientType: type.type == 1 ? "JOINS_MERCHANT" : "JOINS_USER"
        };
        getDownloadCode(data).then((response) => {
          // 提取文件名
          const filename = response.headers["content-disposition"].match(
            /filename=(.*)/
          )[1];
          // 将二进制流转为blob
          const blob = new Blob([response.data], {
            type: "application/octet-stream",
          });
          if (typeof window.navigator.msSaveBlob !== "undefined") {
            // 兼容IE，window.navigator.msSaveBlob：以本地方式保存文件
            window.navigator.msSaveBlob(blob, decodeURI(filename));
          } else {
            // 创建新的URL并指向File对象或者Blob对象的地址
            const blobURL = window.URL.createObjectURL(blob);
            // 创建a标签，用于跳转至下载链接
            const tempLink = document.createElement("a");
            tempLink.style.display = "none";
            tempLink.href = blobURL;
            tempLink.setAttribute("download", decodeURI(filename));
            // 兼容：某些浏览器不支持HTML5的download属性
            if (typeof tempLink.download === "undefined") {
              tempLink.setAttribute("target", "_blank");
            }
            // 挂载a标签
            document.body.appendChild(tempLink);
            tempLink.click();
            document.body.removeChild(tempLink);
            // 释放blob URL地址
            window.URL.revokeObjectURL(blobURL);
            this.searchChange();
          }
        });
      })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消生成通用码"
          });
        });
    },
    /**
     * @title 分类下拉框数据
     *
     **/
    handleSuperior() {
      findWaterProjectAll().then((res) => {
        let data = JSON.parse(res.data)
        this.superiors = data
      })
    },
    formmaterImage(row) {
      let str = new Array();
      JSON.stringify(row);
      if (row != null) {
        let picArray = row.split(",");
        for (let i = 0; i < picArray.length; i++) {
          str.push(picArray[i]);
        }
      }
      return str;
    },
    pageSizeChange(pageSize) {
      this.tableLoading = true;
      let params = this.$refs.crud.searchForm
      params.page = this.page.currentPage,
        params.size = pageSize
      findWaterProject(params).then((res) => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: this.page.currentPage,
          pageSize: pageSize
        };
        this.tableLoading = false;
      })
    },
    pageChange(page) {
      this.tableLoading = true;
      let params = this.$refs.crud.searchForm
      params.page = page
      params.size = this.page.pageSize
      findWaterProject(params).then((res) => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: page,
          pageSize: this.page.pageSize
        };
        this.tableLoading = false;
      })
    },
    searchChange(params) {
      this.tableLoading = true;
      // let params = this.$refs.crud.searchForm
      params.page = this.page.currentPage
      params.size = this.page.pageSize
      this.downloadData = params;
      findWaterProject(params).then((res) => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: params.page,
          pageSize: params.size
        };
        this.tableLoading = false;
      })
    },
    downloadExcelWorkOrder() {
      let params = this.downloadData;
      downloadExcelCustomsDeclaration(params).then((response) => {
        // 提取文件名
        const filename = response.headers["content-disposition"].match(
          /filename=(.*)/
        )[1];
        // 将二进制流转为blob
        const blob = new Blob([response.data], {
          type: "application/octet-stream",
        });
        if (typeof window.navigator.msSaveBlob !== "undefined") {
          // 兼容IE，window.navigator.msSaveBlob：以本地方式保存文件
          window.navigator.msSaveBlob(blob, decodeURI(filename));
        } else {
          // 创建新的URL并指向File对象或者Blob对象的地址
          const blobURL = window.URL.createObjectURL(blob);
          // 创建a标签，用于跳转至下载链接
          const tempLink = document.createElement("a");
          tempLink.style.display = "none";
          tempLink.href = blobURL;
          tempLink.setAttribute("download", decodeURI(filename));
          // 兼容：某些浏览器不支持HTML5的download属性
          if (typeof tempLink.download === "undefined") {
            tempLink.setAttribute("target", "_blank");
          }
          // 挂载a标签
          document.body.appendChild(tempLink);
          tempLink.click();
          document.body.removeChild(tempLink);
          // 释放blob URL地址
          window.URL.revokeObjectURL(blobURL);
          this.searchChange(params);
        }
      });
    },
    refreshChange(page) {
      this.tableLoading = true;
      let params = this.$refs.crud.searchForm
      params.page = page.currentPage
      params.size = page.pageSize
      findWaterProject(params).then((res) => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: page.currentPage,
          pageSize: page.pageSize
        };
        this.tableLoading = false;
      })
    },
    /**
     * @title 打开新增窗口
     * @detail 调用crud的handleadd方法即可
     *
     **/
    handleAdd() {
      // 清空表单
      this.cleanForm();
      this.$refs.crud.rowAdd();
    },
    handleView(row) {
      this.viewId = row.id;
      this.viewDialogVisible = true;
    },
    handleEdit(row) {
      this.editId = row.id;
      this.editDialogVisible = true;
    },
    // 报售后弹窗
    handleAfterSales(row) {
      this.afterSalesId = row.id;
      this.handleAfterSalesDialog = true;
    },

    /**
     * @title 获取数据
     * @detail 赋值为tableData表格即可
     *
     **/
    handleList() {
      this.tableLoading = true;
      let parmas = {
        page: this.page.currentPage,
        size: this.page.pageSize
      }
      findWaterProject(parmas).then((res) => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        
        this.page = {
          total: data.total,
          currentPage: this.page.currentPage,
          pageSize: this.page.pageSize
        };
        getRootDepartmentId().then(res => {
          let data = res.data;
          this.rootDepartmentId = data;
        });
        this.tableLoading = false;
      })
      this.handleSuperior();
    },
    /**
     * @title cleanForm
     */
    cleanForm() {
      this.superior = {};
      this.superior.id = null;
      this.picUrl = "";
      this.fileList = [];
    },
    /**
     * @title 数据添加
     * @param row 为当前的数据
     * @param done 为表单关闭函数
     *
     **/
    handleSave(row, done) {
      row.superiorId = this.superior.id;
      row.picUrl = this.picUrl;
      addWaterProject(row).then(response => {
        if (response.code == '200') {
          this.$message({
            showClose: true,
            message: "添加成功",
            type: "success"
          });
          this.cleanForm();
          this.handleList();
        } else {
          this.$message({
            showClose: true,
            message: response.message,
            type: "error"
          })
        }

      }).catch(error => {
        this.loading = false
        this.$message({
          showClose: true,
          message: error,
          type: "error"
        })
      })
      done();
    },
    /**
     * @title 当前选中的数据
     * @param val 选中的值
     *
     **/
    handleSelectionChange(val) {
      this.tableRow = val;
      /* this.$notify({
          showClose: true,
          message: JSON.stringify(val),
          type: 'success',
      }); */
    },
    /**
     * @title 数据删除
     * @param row 为当前的数据
     * @param index 为当前更新数据的行数
     *
     **/
    handleDel() {
      if (this.$refs.crud.tableSelect.length == 0) {
        this.$message({
          showClose: true,
          message: "请选择要操作的数据",
          type: "error"
        })
        return
      }

      this.$confirm(`是否确认删除?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          let ids = new Array();
          for (let row of this.$refs.crud.tableSelect) {
            ids.push(row.id)
          }

          delWaterProject(ids).then(response => {
            if (response.code == '200') {
              this.$message({
                showClose: true,
                message: "删除成功",
                type: "success"
              });
              this.handleList();
            } else {
              this.$message({
                showClose: true,
                message: response.message,
                type: "error"
              })
            }

          }).catch(error => {
            this.loading = false
            this.$message({
              showClose: true,
              message: error,
              type: "error"
            })
          })
        })
        .catch(() => { });

    },
    /**
     * @title 数据更新
     * @param row 为当前的数据
     * @param index 为当前更新数据的行数
     * @param done 为表单关闭函数
     *
     **/
    handleUpdate(row, index, done) {
      row.superiorId = this.superior.id
      row.picUrl = this.picUrl;
      editWaterProject(row).then(response => {
        if (response.code == '200') {
          this.$message({
            showClose: true,
            message: "修改成功",
            type: "success"
          });
          this.cleanForm();
          this.handleList();
        } else {
          this.$message({
            showClose: true,
            message: response.message,
            type: "error"
          })
        }

      }).catch(error => {
        this.loading = false
        this.$message({
          showClose: true,
          message: error,
          type: "error"
        })
      })
      done();
    },
    handleRebates(row) {
      // 弹出先反显原本金额，返利金额的弹窗

      this.$prompt("请输入返利金额", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        inputPattern: /^\d+(\.\d{1,2})?$/,
        inputValue: row.rebateAmount,
        inputErrorMessage: "请输入正确的金额"
      })
        .then(({ value }) => {
          let params = {
            id: row.id,
            newMoney: value
          }
          handleRebates(params).then(response => {
            if (response.code == '200') {
              this.$message({
                showClose: true,
                message: "返利成功",
                type: "success"
              });
              this.handleList();
            } else {
              this.$message({
                showClose: true,
                message: response.message,
                type: "error"
              })
            }

          }).catch(error => {
            this.loading = false
            this.$message({
              showClose: true,
              message: error,
              type: "error"
            })
          })
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "取消返利"
          });
        });
    },
    handleDetail(row, index) {
      this.superior = {};
      this.superior.id = row.superiorId;
      this.picUrl = row.picUrl;
      this.$refs.crud.rowView(row, index)

    },
    handleBulkDelivery() {
      if (!this.deliveryOrderInfo || this.deliveryOrderInfo.length === 0) {
        this.$message({
          showClose: true,
          message: '请选择要提货的订单',
          type: 'error'
        });
        return;
      }

      // 校验所有必填项
      const isValid = this.deliveryOrderInfo.every(item => {
        return item.warehouseId && item.engineerId && item.installTimeStart && item.installTimeEnd;
      });

      if (!isValid) {
        this.$message({
          showClose: true,
          message: '请填写完整信息',
          type: 'error'
        });
        return;
      }
      // this.deliveryOrderInfo的每一项的status都赋值为'WAIT_FOR_DELIVERY'
      this.deliveryOrderInfo.forEach(item => {
        item.status = 'WAIT_FOR_DELIVERY';
      });
      const params = this.deliveryOrderInfo;
      toBulkDelivery(params).then(res => {
        if (res.code == '200') {
          this.$message({
            showClose: true,
            message: '批量提货成功',
            type: 'success'
          });
          this.handleList();
          this.dialogVisible = false;
        } else {
          this.$message({
            showClose: true,
            message: res.message,
            type: 'error'
          });
        }
      });
    },
    handleMark(row) {
      this.markRow = row;
      this.markType = row.installType || ''; // 如果有默认值
      this.markDialogVisible = true;
    },
    handleMarkOk() {
      setInstallType({ id: this.markRow.id, installType: this.markType }).then(res => {
        if (res.code === "200") {
          this.$message.success('标记成功');
          this.markDialogVisible = false;
          this.handleList();
        } else {
          this.$message.error(res.message || '标记失败');
        }
      }).catch(() => {
        this.$message.error('标记失败');
      });
    },
    // 转货 - 打开弹窗
    openTransferDialog(row) {
      this.transferForm = {
        declarationId: row.declarationId,
        deliveryOrderId: row.id,
        targetEngineerId: '',
        remark: '',
      };
      this.transferEngineerList = [];
      this.transferDialogVisible = true;
    },
    // 转货 - 搜索工程师
    handleTransferEngineerSearch(query) {
      if (/[\u4e00-\u9fa5]/.test(query) || /^\d{8,}$/.test(query)) {
        let params = {
          type: "JOINS_ENGINEER",
          mobile: query,
        };
        findUserList(params).then((res) => {
          if (res.code == "200") {
            let data = JSON.parse(res.data);
            this.transferEngineerList = data.map(item => ({
              ...item,
              realName: item.realName + '(' + item.mobile + ')',
            }));
          }
        });
      }
    },
    // 转货 - 确认
    confirmTransfer() {
      if (!this.transferForm.targetEngineerId) {
        this.$message({ showClose: true, message: '请选择目标工程师', type: 'warning' });
        return;
      }
      const data = {
        projectType: 'PURE_WATER',
        declarationId: this.transferForm.declarationId,
        deliveryOrderId: this.transferForm.deliveryOrderId,
        targetEngineerId: this.transferForm.targetEngineerId,
        remark: this.transferForm.remark || '',
      };
      transferGoods(this.transferForm.declarationId, data).then(res => {
        if (res.code === "200") {
          this.$message.success('转货成功');
          this.transferDialogVisible = false;
          // 重新加载提货单弹窗内的数据
          if (this.currentDeliveryRow) {
            this.handleDelivery(this.currentDeliveryRow);
          }
          this.handleList();
        } else {
          this.$message.error(res.message || '转货失败');
        }
      }).catch(() => {
        this.$message.error('转货失败');
      });
    },
    // 退货 - 打开弹窗
    openReturnGoodsDialog(row) {
      // 只退当前行对应的产品，最大数量为该行的实际数量
      this.returnGoodsForm = {
        declarationId: row.declarationId,
        deliveryOrderId: row.id,
        warehouseId: '',
        remark: '',
        goodsList: [{
          goodsId: row.goodsId,
          goodsName: row.goodsRealName || row.productName,
          num: 0,
          maxNum: row.goodsNum || 0,
        }],
      };
      this.returnGoodsDialogVisible = true;
    },
    // 退货 - 确认
    confirmReturnGoods() {
      if (!this.returnGoodsForm.warehouseId) {
        this.$message({ showClose: true, message: '请选择退回前仓', type: 'warning' });
        return;
      }
      const validGoods = this.returnGoodsForm.goodsList.filter(item => item.num > 0);
      if (validGoods.length === 0) {
        this.$message({ showClose: true, message: '请输入退货数量', type: 'warning' });
        return;
      }
      const data = {
        projectType: 'PURE_WATER',
        declarationId: this.returnGoodsForm.declarationId,
        deliveryOrderId: this.returnGoodsForm.deliveryOrderId,
        warehouseId: this.returnGoodsForm.warehouseId,
        remark: this.returnGoodsForm.remark || '',
        goodsList: validGoods.map(item => ({
          goodsId: item.goodsId,
          num: item.num,
          goodsName: item.goodsName,
        })),
      };
      returnGoods(this.returnGoodsForm.declarationId, data).then(res => {
        if (res.code === "200") {
          this.$message.success('退货成功');
          this.returnGoodsDialogVisible = false;
          // 重新加载提货单弹窗内的数据
          if (this.currentDeliveryRow) {
            this.handleDelivery(this.currentDeliveryRow);
          }
          this.handleList();
        } else {
          this.$message.error(res.message || '退货失败');
        }
      }).catch(() => {
        this.$message.error('退货失败');
      });
    },
    // 操作日志 - 打开弹窗
    openOperationLogDialog(row) {
        console.log(row)
      this.operationLogDialogVisible = true;
      this.operationLogList = [];
      this.operationLogLoading = true;
      const operationTypeMap = {
        'TRANSFER': '转货',
        'TRANSFER_CONFIRM': '转货确认',
        'RETURN_GOODS': '退货',
        'RETURN_GOODS_CONFIRM': '退货确认',
      };
      // /v1/delivery_order/operation_log?goodsId=xxx&declarationId=XX
      const params = {
        goodsId: row.goodsId,
        declarationId: row.declarationId,
      };
      getDeliveryOrderOperationLog(params).then(res => {
        if (res.code === "200") {
          let data = typeof res.data === 'string' ? JSON.parse(res.data) : res.data;
          this.operationLogList = (data || []).map(item => ({
            ...item,
            operationTypeText: operationTypeMap[item.operationType] || item.operationType,
          }));
        } else {
          this.$message.error(res.message || '获取操作日志失败');
        }
        this.operationLogLoading = false;
      }).catch(() => {
        this.$message.error('获取操作日志失败');
        this.operationLogLoading = false;
      });
    },
  }
};
</script>

<style lang="scss" scoped>
.table-container {
  padding: 8px 10px;
}

.demo-table-expand {
  font-size: 0;
}

.demo-table-expand label {
  width: 90px;
  color: #99a9bf;
}

.demo-table-expand .el-form-item {
  margin-right: 0;
  margin-bottom: 0;
  width: 50%;
}

::v-deep .el-table--medium td {
  padding: 0 !important;
}

::v-deep .el-table {
  font-size: 12px !important;
}

::v-deep .el-form-item {
  margin-bottom: 0px !important;
}

::v-deep .el-table--medium th {
  padding: 0px !important;
}

::v-deep .el-table td .el-table th {
  padding: 0px !important;
}

.typeButton {
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
  align-items: center;
  margin-top: 50px;
}

.el-row {
  margin-bottom: 20px;

  &:last-child {
    margin-bottom: 0;
  }
}

.el-col {
  border-radius: 4px;
}

.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}

.clearfix:after {
  clear: both
}

.box-card {
  width: 480px;
}
</style>